import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./myteam.module.css";
import { authApi, getAuthorizationHeader } from "../../../api-calls/user-requests";
import { ADD_DEPARTMENT } from "../../../api-calls/api-urls";
import image from "../../../assets/images/NoTeam.png";
import { Checkbox, FormControlLabel, Box, Grid, Card, CardContent, MenuItem, Menu, Typography, Button, Paper } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { departmentLists } from "../../../Redux/actions/team-actions";
import { BsThreeDotsVertical } from "react-icons/bs";
import AddDepartmentModal from "./AddDepartmentModel";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  DeleteBinIcons,
  EditPenIcon,
  RoundAddIcon,
} from "../../../components/Icons";
import DeleteConformation from "./DeleteConformation";
import AlertBox from "../../../components/AlertBox";

const DepartMentIndex = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState();
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const departmentList = useSelector(
    (state) => state.teams.departmentList
  );
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [userEntry, setUserEntry] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount (getLanguagedataFunction is idempotent)

  const handleCheckboxChange = (value, name) => {
    if (name === "single") {
      const isSelected = selectedValues.includes(value);
      let newSelectedValues = [];

      if (isSelected) {
        newSelectedValues = selectedValues.filter((v) => v !== value);
      } else {
        newSelectedValues = [...selectedValues, value];
      }
      setSelectedValues(newSelectedValues);
      setSelected();
    } else if (name === "all") {
      if (value) {
        let ids = departmentList.map((item) => item._id);
        setSelectedValues(ids);
        setSelected();
      } else {
        setSelectedValues([]);
        setChecked(!checked);
        setSelected();
      }
    }
  };

  const handleClick = () => {
    setModal(true);
    setSelected(null);
  };
  const CloseForm = () => {
    getDEpartmnetData();
    setModal(false);
    setSelected(null);
  };
  const handleMenuclick = (event, item) => {
    event.stopPropagation();
    setSelected(item);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    // setSelected(null);
  };

  const closeModal = () => {
    setDeleteModal(false);
    getDEpartmnetData();
  };

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  const handleMenuItemClick = async (event, name) => {
    if (name === "edit") {
      setModal(true);
      handleClose();
    } else if (name === "deleteAtTop") {
      // The top "delete selected" button always acts on the checkbox
      // selection — never on `selected`, which is only ever set by opening
      // a *row's* ⋮ menu and is unrelated state left over from that. Using
      // it here (as this used to) meant that once any row's menu had been
      // opened once, this button would delete only that one stale row
      // instead of the actual checked departments.
      if (selectedValues.length > 0) {
        setUserEntry({ departmentIds: selectedValues });
        setDeleteModal(true);
        handleClose();
      } else {
        setShowAlert(true);
        setError("Please select atleast one department");
      }
    } else if (name === "delete") {
      // Triggered only from a row's own ⋮ menu, so `selected` (set by
      // handleMenuclick when that menu opened) is always this specific row
      // — never the checkbox selection.
      if (selected) {
        setUserEntry({ departmentIds: [selected._id] });
        setDeleteModal(true);
        handleClose();
      } else {
        setShowAlert(true);
        setError("Please select atleast one department");
      }
    }
  };

  const getDEpartmnetData = async () => {
    try {
      const { data } = await authApi.get(ADD_DEPARTMENT, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      dispatch(departmentLists(data));
    } catch (error) {
      // Intentionally ignored — not surfaced to the user
    }
  };

  useEffect(() => {
    getDEpartmnetData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!departmentList]);

  return (
    <div>
      {ln ? (
        <div>
          {departmentList && departmentList.length > 0 ? (
            <div className={classes.indexpageMainBtn}>
              <Button
                variant="contained"
                className={`${classes.noDataImagePAge}`}
                onClick={() => handleClick()}
              >
                <RoundAddIcon />
                <span>{ln.create_department}</span>
              </Button>
            </div>
          ) : null}
          <Paper
            className={classes.CreateTeamindex}
            style={{ padding: "5px 20px" }}
          >
            {departmentList && departmentList.length > 0 ? (
              <div>
                <div>
                  <div className={classes.TaskContainerheader}>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              selectedValues.length === departmentList?.length
                            }
                            onChange={(e) =>
                              handleCheckboxChange(e.target.checked, "all")
                            }
                            size="small"
                            icon={<CheckBoxOutlineBlankIcon sx={{ color: 'rgba(0, 0, 0, 0.54) !important' }} />}
                            checkedIcon={<CheckBoxIcon sx={{ color: '#227dc3 !important' }} />}
                            sx={{
                              '& .MuiSvgIcon-root': {
                                opacity: '1 !important',
                              },
                            }}
                          />
                        }
                        label={`${selectedValues?.length}/${departmentList?.length} departments selected`}
                        className={classes.taskCheckbox}
                      />
                    </Box>
                    <div className={classes.deleteIcon}>
                      <Button
                        variant="text"
                        style={{ padding: "0px", minWidth: "0px" }}
                        onClick={(e) => handleMenuItemClick(e, "deleteAtTop")}
                      >
                        <DeleteBinIcons />
                      </Button>
                    </div>
                  </div>
                  <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                      {departmentList.map((item) => {
                        return (
                          <Grid item xs={12} sm={6} md={4} key={item._id}>
                            <Card className={classes.teamCard}>
                              <CardContent
                                className={`${classes.teamCardContainer} ${classes.departmentCerdContainer}`}
                                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                              >
                                <Checkbox
                                  checked={selectedValues.includes(item._id)}
                                  onChange={() =>
                                    handleCheckboxChange(item._id, "single")
                                  }
                                  size="small"
                                  icon={<CheckBoxOutlineBlankIcon sx={{ color: 'rgba(0, 0, 0, 0.54) !important' }} />}
                                  checkedIcon={<CheckBoxIcon sx={{ color: '#227dc3 !important' }} />}
                                  sx={{
                                    '& .MuiSvgIcon-root': {
                                      opacity: '1 !important',
                                    },
                                  }}
                                />
                                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, ml: 1, overflow: 'hidden' }}>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      mr: 1,
                                      fontWeight: 600,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {item.department_name}
                                  </Typography>
                                  <CircleIcon
                                    style={{ color: `${item.colour}`, fontSize: 14, flexShrink: 0 }}
                                  />
                                </Box>
                                <Box>
                                  <Button
                                    variant="text"
                                    className={classes.CardMenu}
                                    onClick={(e) => handleMenuclick(e, item)}
                                    sx={{ minWidth: 0 }}
                                  >
                                    <BsThreeDotsVertical />
                                  </Button>
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                </div>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      borderRadius: '12px',
                      minWidth: '130px',
                      mt: 0.5,
                      '& .MuiMenuItem-root': {
                        px: 2,
                        py: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                      },
                    }
                  }}
                >
                  <MenuItem onClick={(e) => handleMenuItemClick(e, "edit")}>
                    <EditPenIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Edit</Typography>
                  </MenuItem>
                  <MenuItem onClick={(e) => handleMenuItemClick(e, "delete")}>
                    <DeleteBinIcons sx={{ fontSize: 20, color: 'error.main' }} />
                    <Typography variant="body2" color="error" sx={{ fontWeight: 500 }}>Delete</Typography>
                  </MenuItem>
                </Menu>
                {deleteModal ? (
                  <DeleteConformation
                    modalClose={closeModal}
                    type={"Department"}
                    selected={selected}
                    idsList={userEntry}
                  />
                ) : null}
              </div>
            ) : (
              <div className={classes.imagePagemaindiv}>
                <img
                  src={image}
                  alt="createTeam"
                  className={classes.CreateTeamimage}
                />
                <Typography className={classes.imagePageText} variant="h5">
                  You don't have any departments currently. Please create a
                  departments to view here.
                </Typography>
                <Button
                  variant="contained"
                  className={`${classes.imagepagebtn} ${classes.noDataImagePAge}`}
                  onClick={() => handleClick()}
                >
                  <RoundAddIcon />
                  <span>{ln.create_department}</span>
                </Button>
              </div>
            )}
          </Paper>
          {modal ? (
            <AddDepartmentModal modalClose={CloseForm} department={selected} />
          ) : null}
        </div>
      ) : null}
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default DepartMentIndex;
